/* eslint-disable max-len */
import React from 'react';
import { createUseStyles } from 'react-jss';
import classNames from 'classnames';
import { Stack, StackItem } from '@fluentui/react';
import { PlaygroundTheme } from '../../Theme';

const useStyles = createUseStyles<string, unknown, PlaygroundTheme>(() => ({
  topicCardContainer: {
    cursor: 'pointer',
    width: 368,
    height: 120,
    borderRadius: 24,
    background: '#FFFFFF',
    transition: '300ms',

    '&:hover': {
      transform: 'scale(1.05)',
      background: '#EBEBEB',
    },

    '& img': {
      width: 96,
      height: 96,
      borderRadius: 12,
      objectFit: 'cover',
    },
    '& .img-body': {
      color: '#050505',
      fontWeight: 'bold',
      fontSize: '16px',
      lineHeight: '20px',
      '& .cnLanguage': {
        color: '#7A7A7A',
        fontWeight: 400,
        fontSize: '14px',
        lineHeight: '20px',
        marginTop: 8,
      },
    },
  },
}));

interface ITopicCardProps {
  className?: string;
  imgsrc: string;
  style?: object;
  imgStyle?: object;
  text: string;
  cnText: string;
  onClick: () => void;
}

export const TopicCard: React.FC<ITopicCardProps> = ({
  className, imgsrc, style, imgStyle, text, cnText, onClick,
}) => {
  const classes = useStyles();

  return (
    <Stack
      horizontal
      verticalAlign="center"
      tokens={{ childrenGap: 16, padding: '12px' }}
      className={classNames('content-card-container', classes.topicCardContainer, className)}
      role="button"
      style={style}
      tabIndex={0}
      onClick={() => onClick()}
      onKeyDown={() => onClick()}
    >
      <StackItem>
        <img src={imgsrc} alt={text} style={imgStyle} />
      </StackItem>
      <StackItem className="img-body">
        <div>{text}</div>
        <div className="cnLanguage">{cnText}</div>
      </StackItem>
    </Stack>
  );
};

TopicCard.defaultProps = {
  style: {},
  imgStyle: {},
};
